import { Component, OnInit } from '@angular/core';
import { OrgsettingsService } from './service/orgsettings.service';
import { Orgsetting } from './model/orgsetting';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { FormsModule } from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgsettings',
  templateUrl: './orgsettings.component.html',
  styleUrl: './orgsettings.component.css'
})
export class OrgsettingsComponent implements OnInit {
  orgsettings:Orgsetting;
  responseMessage:string;
  showSpinner:boolean = false;
  updated:boolean = false;
  constructor(private orgsettingsService:OrgsettingsService) { }

  ngOnInit(): void {
    this.orgsettings = new Orgsetting;
    this.orgsettings.orglanguage = 'EN';
    //Get the organization settings
    this.orgsettingsService.getOrgSettings().pipe(untilDestroyed(this)).subscribe((setting)=>{
     //console.log(setting);
      if(setting == null){
        
      }else{
        
        if(setting.orglanguage == null){
          //setting.orglanguage = 'EN';
        }
        this.orgsettings = setting;
      }
    });

  }
  updateOrgSettings(){
    this.showSpinner = true;
    this.orgsettingsService.updateOrgSettings(this.orgsettings).pipe(untilDestroyed(this)).subscribe((resp)=>{
      //OK message
      this.responseMessage = resp.toString();
     //console.log(resp);
      this.showSpinner = false;
      this.updated = true;
    });
  }

}
